export default __webpack_public_path__ + "media/images/backgrounds/bg-5-ecdfc6ebf93528f5086b1b65ccf36c5e.jpg";